import React from 'react';
import { Card, CardContent, CardHeader, Divider } from '@mui/material';
import Page from '../../components/commonComponents/Page';
import LoadingScreen from '../../components/commonComponents/LoadingScreen';
import useLocales from '../../hooks/useLocales';
import IdmEmailTemplateList from '../../components/configurationsComponents/idmEmailTemplate/IdmEmailTemplateList';
import { IdmEmailTemplateAddEditDialog } from '../../components/configurationsComponents/idmEmailTemplate/IdmEmailTemplateAddEditDialog';
import { dispatch } from '../../redux/store';
import { updateDashboardTitle } from '../../redux/reducersAndActions/dashboardActionsAndReducers';
import { useIdmEmailTemplates } from '../../hooks/useEmailTemplate';

export default function IdmEmailTemplatePage() {
  const { translate } = useLocales();
  const { templates, loading, open, selectedTemplate, handleOk, handleCancel, handleShowEdit } = useIdmEmailTemplates();

  React.useEffect(() => {
    dispatch(updateDashboardTitle({ title: translate('PageTitle.IdmEmailTemplatePage') }));
  }, []);

  const currentTemplate = React.useMemo(
    () => templates.find(t => t.templateType === selectedTemplate) ?? null,
    [templates, selectedTemplate]
  );

  return (
    <Page title={translate('IdmEmailTemplate.PageTitle')}>
      <Card style={{ height: '75vh', overflow: 'auto' }}>
        {loading && <LoadingScreen />}
        <CardHeader title={translate('IdmEmailTemplate.ListTitle')} sx={{ color: '#70818d', fontWeight: 'bold' }} style={{ paddingBottom: '10px' }} />
        <Divider sx={{ borderBottomWidth: 1 }} />
        <CardContent style={{ padding: '0px' }} >
          <IdmEmailTemplateList
            handleShowEdit={handleShowEdit}
            templates={templates}
          />
        </CardContent>
      </Card >
      {open && currentTemplate &&
        <IdmEmailTemplateAddEditDialog
          open={open}
          onClose={handleCancel}
          onSave={handleOk}
          template={currentTemplate} />
      }
    </Page >
  );
}